import { SettingsTab } from '../components/settingsComponents/SettingsTab';
import { AppLayout } from '../layout/AppLayout';
import { DashboardLayout } from '../layout/DashboardLayout';

export function Settings() {
  return (
    <AppLayout>
      <DashboardLayout title="Settings">
        <SettingsTab />
      </DashboardLayout>
    </AppLayout>
  );
}
